import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, SparklesIcon } from 'lucide-react';
interface FeaturedBrandsCarouselProps {
  brands: Array<{
    id: number;
    name: string;
    logo: string;
    discount: number;
    description: string;
  }>;
}
export function FeaturedBrandsCarousel({
  brands
}: FeaturedBrandsCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % brands.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + brands.length) % brands.length);
  };
  return <>
      <div className="bg-gradient-to-r from-[#1E2B55] to-[#162041] rounded-xl p-6 text-white" data-id="element-2320" data-mp="1fr8s4obltifr">
        <div className="flex items-center justify-between mb-6" data-id="element-2321" data-mp="1arnt6dwfpa31">
          <div className="flex items-center gap-3" data-id="element-2322" data-mp="3hidg9aebw0vc">
            <div className="bg-yellow-400 p-2 rounded-full" data-id="element-2323" data-mp="3hj52vvpy6o9h">
              <SparklesIcon className="w-6 h-6 text-[#1E2B55]" data-id="element-2324" data-mp="3cjiqtpluve29" />
            </div>
            <div data-id="element-2325" data-mp="14fclrokisuqj">
              <h2 className="text-2xl font-bold" data-id="element-2326" data-mp="14fuqzap5ujal">Featured Brands</h2>
              <p className="text-white text-opacity-80" data-id="element-2327" data-mp="14dhyi3ls0qja">
                Exclusive deals from top brands
              </p>
            </div>
          </div>
          <div className="flex gap-2" data-id="element-2328" data-mp="1ech8bpia2s7v">
            <button onClick={prevSlide} className="bg-white bg-opacity-20 hover:bg-opacity-30 p-2 rounded-lg transition-all" data-id="element-2329" data-mp="1ebfp2xr3yzf2">
              <ChevronLeftIcon className="w-6 h-6" data-id="element-2330" data-mp="1n51149bw22ks" />
            </button>
            <button onClick={nextSlide} className="bg-white bg-opacity-20 hover:bg-opacity-30 p-2 rounded-lg transition-all" data-id="element-2331" data-mp="1s447py7ioguv">
              <ChevronRightIcon className="w-6 h-6" data-id="element-2332" data-mp="223368nykiw45" />
            </button>
          </div>
        </div>

        <div className="relative overflow-hidden" data-id="element-2333" data-mp="2pz3ilyry8xo">
          <div className="flex transition-transform duration-500 ease-out" style={{
          transform: `translateX(-${currentIndex * (100 / (window.innerWidth < 768 ? 1 : 4))}%)`
        }} data-id="element-2334" data-mp="2raf37ygokzc">
            {brands.map((brand, index) => <div key={brand.id} className="flex-shrink-0 w-full md:w-1/4 px-2" data-id="element-2335" data-mp="3qvqnckv6rqqi" data-mpi={index}>
                <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 h-full border border-white/10" data-id="element-2336" data-mp="9nv7kb2iv50r">
                  <div className="bg-white rounded-lg p-4 mb-4 h-24 flex items-center justify-center" data-id="element-2337" data-mp="4pto3p16p3or">
                    <img src={brand.logo} alt={brand.name} className="max-w-full max-h-full object-contain" data-id="element-2338" data-mp="ikvv6fhroz35" />
                  </div>
                  <h3 className="font-bold text-lg mb-1" data-id="element-2339" data-mp="ne8c03g7g1lc">{brand.name}</h3>
                  <p className="text-sm text-white text-opacity-80 mb-3" data-id="element-2340" data-mp="ngb4qv8qs8tr">
                    {brand.description}
                  </p>
                  <div className="bg-yellow-400 text-[#1E2B55] font-bold text-center py-2 rounded-lg" data-id="element-2341" data-mp="xcxmhb5rujrk">
                    Up to {brand.discount}% OFF
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </>;
}